<p-card>
  <h1>Heading 1</h1>
  <h2>Heading 2</h2>
  <h3>Heading 3</h3>
  <h4>Heading 4</h4>
  <p class="p1 mb-3">Paragraph 1</p>
  <p class="p2 mb-3">Paragraph 2</p>
  <p class="p3 mb-3">Paragraph 3</p>
  <p class="p4 mb-3">Paragraph 4</p>
  <p class="p1"><a href="#">Link</a></p>
</p-card>
